export default "__VITE_ASSET__CBJNSode__"